import { render, staticRenderFns } from "./KafkaSwitchManagement.vue?vue&type=template&id=6c42b958&scoped=true&"
import script from "./KafkaSwitchManagement.vue?vue&type=script&lang=js&"
export * from "./KafkaSwitchManagement.vue?vue&type=script&lang=js&"
import style0 from "./KafkaSwitchManagement.vue?vue&type=style&index=0&id=6c42b958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c42b958",
  null
  
)

export default component.exports